import React from 'react';

/**
 * Custom Hook to validate children against an Array of allowed Component Types.
 * If an invalid Child Type is found, it throws an Error.
 *
 * @param {React.ReactNode} children - The children to be validated.
 * @param {Array<React.ComponentType>} allowedTypes - The Array of allowed Component Types.
 * @throws {Error} Throws an Error if any child is not in the allowedTypes Array.
 */
export default function checkChildren(children, allowedTypes) {
  React.Children.forEach(children, child => {
    if (!React.isValidElement(child)) {
      throw new Error(
        `Children must be of the allowed types: ${allowedTypes
          .map(type => `<${type.name}>`)
          .join(', ')}`
      );
    }
  });

  React.Children.forEach(children, child => {
    if (!React.isValidElement(child)) return;

    const childType = child.type;
    const isChildTypeValid = allowedTypes.some(
      allowedType => allowedType === childType
    );

    if (!isChildTypeValid) {
      throw new Error(
        `Children must be of the allowed types: ${allowedTypes
          .map(type => `<${type.name}>`)
          .join(', ')}`
      );
    }
  });
}
